import React from 'react'
import PropTypes from 'prop-types'
import Tooltip from '../Tooltip'
import { classNames } from '../../util/helpers'

import styles from './AppIcon.module.scss'

const AppIcon = ({ help, close, info, remove, onClick, toolTipMessage }) => {
  const div = (
    <div
      role="presentation"
      onClick={onClick}
      className={classNames(
        styles.appIcon,
        onClick && styles.onClick,
        help && styles.help,
        close && styles.close,
        info && styles.info,
        remove && styles.remove,
      )}
    />
  )

  if (toolTipMessage) {
    return <Tooltip content={toolTipMessage}>{div}</Tooltip>
  }

  return div
}
AppIcon.propTypes = {
  onClick: PropTypes.func,
  help: PropTypes.bool,
  close: PropTypes.bool,
  info: PropTypes.bool,
  remove: PropTypes.bool,
  toolTipMessage: PropTypes.string,
}

AppIcon.defaultProps = {
  onClick: () => {},
  help: false,
  close: false,
  info: false,
  remove: false,
  toolTipMessage: '',
}

export default AppIcon
